module.exports = __webpack_public_path__ + "public/hws/images/logo_zbj.png";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/logo_zbj.png
// module id = 337
// module chunks = 0